<template>
  <div class="side-nav">

    <el-menu :default-active.sync="activeLink"
             :mode="mode"
             @select="goto"
             :collapse="isCollapse"
             :unique-opened="true"
             :class="{'nav-collapsed':isCollapse}">
      <div v-for="(obj,index) in menus"
           :key="index">

        <el-submenu v-if="obj.childrens.length"
                    :index="obj.name">
          <template slot="title">
            <i :class="obj.icon"
               :test_id="obj.test_id"></i>
            <span v-show="!isCollapse">{{$t('menu.' + obj.lang_key)}}</span>
          </template>
          <el-menu-item-group>
            <div :key="a"
                 v-for="(j,a) in obj.childrens">
              <el-menu-item v-if="j.lang_key == 'subAccount' && zoneinfo.name === 'China'"
                            :index="j.link"
                            :test_id="j.test_id">{{$t('menu.' + j.lang_key)}}</el-menu-item>
              <el-menu-item v-else-if="j.lang_key != 'subAccount'"
                            :index="j.link"
                            :test_id="j.test_id">{{$t('menu.' + j.lang_key)}}</el-menu-item>
            </div>
          </el-menu-item-group>
        </el-submenu>
        <!-- <el-submenu :index="obj.name">
          <template slot="title">
            <i :class="obj.icon"></i>
            <span v-show="!isCollapse">{{$t('menu.' + obj.lang_key)}}</span>
          </template>
          <el-menu-item-group>
            <div :key="a" v-for="(j,a) in obj.childrens" >
              <el-menu-item v-show="$getProfile().custom.accountNumber != undefined" v-if="j.lang_key == 'subAccount' && zoneinfo.name == 'China'" :index="j.link">{{$t('menu.' + j.lang_key)}}</el-menu-item>
              <el-menu-item v-show="$getProfile().custom.accountNumber != undefined" v-else-if="j.lang_key != 'subAccount'" :index="j.link">{{$t('menu.' + j.lang_key)}}</el-menu-item>
              <el-menu-item v-show="$getProfile().custom.accountNumber == undefined && j.lang_key == 'setting'" :index="j.link">{{$t('menu.' + j.lang_key)}}</el-menu-item>
            </div>
          </el-menu-item-group>
        </el-submenu> -->

        <!-- <el-menu-item v-show="$getProfile().custom.accountNumber != undefined" :index="obj.link">
          <i :class="obj.icon"></i>
          <span slot="title">{{$t('menu.' + obj.lang_key)}}</span>
        </el-menu-item>

        <el-menu-item v-show="$getProfile().custom.accountNumber != undefined" id="menu-deposit" :index="obj.link">
          <i :class="obj.icon"></i>
          <span slot="title">{{$t('menu.' + obj.lang_key)}}</span>
        </el-menu-item>

        <el-menu-item v-show="$getProfile().custom.accountNumber != undefined" :index="obj.link">
          <i :class="obj.icon"></i>
          <span slot="title">{{$t('menu.' + obj.lang_key)}}</span>
        </el-menu-item> -->

        <el-menu-item v-else
                      :index="obj.link"
                      :test_id="obj.test_id">
          <!-- <i v-if="obj.type"
             class="icon-home">
            <span class="path1"></span>
            <span class="path2"></span>
          </i> -->
          <img v-if="obj.type" class="icon-home" src="@/assets/images/home_default.svg" alt="logo"/>
          <i v-else
             :class="obj.icon"></i>
          <span slot="title">{{$t('menu.' + obj.lang_key)}}</span>
        </el-menu-item>

        <!-- <el-menu-item :index="obj.link">
          <i v-if="obj.type" class="icon-home">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <i v-else :class="obj.icon"></i>

          <span slot="title">{{$t('menu.' + obj.lang_key)}}</span>
        </el-menu-item> -->
      </div>

    </el-menu>
    <el-dialog class="error-dialog"
                  :visible.sync="spdialogOpen"
                  :title="$t('logout.tips')"
                  width="30%">
                  <div>{{$t('common.spInfo')}}</div>
                  <div slot="footer" class="footer-box">
                    <el-button style="width:40%;margin-left:0;" type="primary" @click="spdialogOpen=false">{{$t('common.ok')}}</el-button>
                  </div>
     </el-dialog>
  </div>
</template>

<script>
import { detect } from 'detect-browser'
import { constantRouterMap } from '../router'
import menus1 from '../config/menus'
import companyMenus from '../config/company-menus'
import countryCodes from 'country-code-info'
import eventBus from '@/util/eventBus'
// import { filter } from 'bluebird'
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'

const browser = detect()
export default {
  name: 'Nav',
  props: ['mode', 'isCollapse'],
  data () {
    return {
      isIe: true,
      isEdge: true,
      activeLink: null,
      spdialogOpen: false
    }
  },
  computed: {
    ...mapGetters(['getAccountInfo', 'getClientProfile', 'getAccountOpeningAgreement', 'getAccountOpening']),
    ...mapState(['userInfo', 'filterSPTradingAccountList']),
    nationality () {
      return this.getClientProfile && this.getClientProfile.userInfo ? this.getClientProfile.userInfo.issuingCountry : ''
    },
    zoneinfo () {
      return countryCodes.findCountry({ 'a3': this.nationality }) || { name: '' }
    },
    menus () {
      let filterArrParents = ['logout', 'my_accout', 'home']
      let filterArrChildrens = ['setting']
      let arr1 = []
      // if (this.getAccountInfo.length === 0) {
      //   return []
      // }
      if (!this.getAccountOpening) {
        // TODO 数组深拷贝
        const newMenu = JSON.parse(JSON.stringify(menus1))
        arr1 = this.remove(filterArrParents, newMenu)
        for (let i = 0; i < arr1.length; i++) {
          if (arr1[i].childrens && arr1[i].childrens.length) {
            arr1[i].childrens = this.remove(filterArrChildrens, arr1[i].childrens)
          }
        }
        return arr1
      }
      // 公司账户菜单
      if (this.userInfo.type === 'COMPANY') {
        return companyMenus
      }
      return menus1
    },
    isOnlySP() {
      return this.userInfo.isSPAccount === 'Y' && !this.filterSPTradingAccountList.length
    }
  },
  methods: {
    remove (arr, menus) {
      let _arr = []
      _arr = _.remove(menus, (item) => {
        return arr.includes(item.lang_key)
      })
      return _arr
    },
    goto (index, indexPath) {
      // 取款内部转账换汇 只有sp账户时弹窗拦截
      if (['/withdrawal', '/fund-transfer', '/exchange'].includes(index) && this.isOnlySP) {
        return (this.spdialogOpen = true)
      }
      if (index.charAt(0) === '/') {
        if (localStorage.getItem('notNeedPush')) {
          eventBus.$emit('openDialog', index)
          return
        }
        this.$router.push(index)
        this.$emit('push-page', {
          page: index
        })
      }
    },
    setLink (path) {
      this.activeLink = path
    }
  },
  created () {
    if (browser.name !== 'ie') this.isIe = false
    if (browser.name !== 'edge') this.isEdge = false

    this.setLink(this.$router.currentRoute.path)
    this.$router.afterEach((to, from) => {
      this.setLink(this.$router.currentRoute.path)
    })
  },
  mounted () {
    // console.log(constantRouterMap)
  }
}
</script>

<style lang="scss">
.side-nav {
  .el-menu {
    background: none;
    color: #001e50;
    font-weight: 600;
  }
  .el-menu-item.is-active {
    font-weight: 800;
    color: #001e50;
    background-color: #e9e9e9;
  }
  .el-menu-item:hover,
  .el-menu-item:focus {
    background-color: #e9e9e9;
  }
  .el-menu-item {
    color: #001e50;
  }
  .el-submenu__title:hover {
    background-color: #e9e9e9;
    font-weight: bold;
  }
  .el-submenu__title {
    color: #001e50;
  }
  .el-submenu__title i.el-submenu__icon-arrow {
    font-size: 18px;
    color: #fec000;
  }
  .el-menu-item i,
  .el-submenu__title i {
    padding-right: 18px;
    vertical-align: middle;
    font-size: 24px;
  }
  .el-menu-item-group > ul {
    text-indent: 18px;
  }
  .el-icon-arrow-right {
    color: #f4f4f4;
  }
  .icon-home {
    width: 24px;
    height: 24px;
    margin-right: 18px;
  }
}
</style>
